import { useEffect } from 'react';
import { useAuth } from '@core/features-core/auth/client';
import Script from 'next/script';

export const GetSiteControlConfig = () => {
  const { initialized, userIsPremium, userIsLogged } = useAuth();

  /**
   * Apply user profile to GetSiteControl context
   */
  useEffect(() => {
    try {
      if (!initialized) return;

      if (!userIsLogged) {
        (window as any).gsc('params', { userIsOpen: true });
      } else if (userIsLogged && !userIsPremium) {
        (window as any).gsc('params', { userIsLogged: true });
      } else if (userIsPremium) {
        (window as any).gsc('params', { userIsPrime: true });
      }
    } catch (error) {}
  }, [initialized, userIsPremium]);

  return (
    <Script
      async
      dangerouslySetInnerHTML={{
        __html: `window.gsc=window.gsc||function(){(gsc.q=gsc.q||[]).push(arguments)};`,
      }}
    />
  );
};
